import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";

import Container from "@material-ui/core/Container";
import {
  useStylesContainers,
  useStylesHed,
  useStylesSetting,
} from "../../../St/comps/UseStyle";

import { Toaster } from "react-hot-toast";
import useFormDataCRUD from "../../../components/Hooks/useEDSCURD";

import Swipeable from "../../../Fronts/Main/Swipeable";
import { Button } from "@material-ui/core";
import axios from "axios";
import { uri } from "../../../help/Api";
import SubscriptionRenewForm from "./subscription-renew-form";
import moment from "moment";
import { useTranslation } from "react-i18next";

const URL = uri + "Foundation";

function postRenew(data) {
  return axios.post(URL, data);
}

function getDfault(collection) {
  const index = collection?.findIndex((c) => c.IS_Default);
  if (index >= 0) {
    return collection[index];
  } else if (index == -1) {
    return collection[0];
  }
  return null;
}
export default function SubscriptionRenew(props) {
  const { data, fetchURL } = props;
  const { t } = useTranslation(["forms"]);
  const classesStt = useStylesSetting();

  const defaultValues = {
    StopWorkingDate :moment(data?.StopWorkingDate?? data?.StartWorkDate ).format("YYYY-MM-DD"),
    StartWorkDate: moment(data?.StartWorkDate).format("YYYY-MM-DD"),
    key :"",
    isPossible: false,
    countOfMonths:0,
    foundId: data?.id,
  };

  const { onChange, submit, update, submitting, object } = useFormDataCRUD(
    postRenew,
    undefined,
    undefined,
    undefined,
    defaultValues,
    null,
    fetchURL
  );

  const clsConts = useStylesContainers();
  const clashd = useStylesHed();

  const styheader = {
    textAlign: "center",
    backgroundColor: "#fff",
    height: "100vh",
    direction: "rtl",
  };

  return (
    <React.Fragment>
      <CssBaseline />

      <Container maxWidth="sm">
        <Toaster />

        <Typography component="div" style={styheader}>
          <Grid item container>
            <Grid item xs={12}>
              <Chip
                size="small"
                className={clashd.ChipHdSale}
                label={t("renew-subscription")}
                color="primary"
              />
            </Grid>
            <Grid container xs={12}>
              <Grid
                item
                container
                lg={12}
                md={12}
                sm={12}
                sx={12}
                className={[clsConts.rootup]}
              >
                <Grid
                  item
                  container
                  spacing={2}
                  xs={12}
                  className={[clsConts.subUp, clsConts.subUpC]}
                >
                  <SubscriptionRenewForm
                    {...{
                      data,
                      object,
                      updateItems: submit,
                      onChange,
                    }}
                  />
                  <Grid item container className={classesStt.rootSett}>
                    <Button
                      variant="contained"
                      className={classesStt.btn}
                      color="primary"
                      fontSize="large"
                      disabled={!object?.isPossible || submitting}
                      onClick={async () => {
                        await submit(object);
                      }}
                    >
                      {t("save-changes")}
                    </Button>
                    <Swipeable />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Typography>
      </Container>
    </React.Fragment>
  );
}
